var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1422_54208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5295 21.3485L30.8217 33.5801H27.4186L20.6519 23.5991V23.5985L19.6585 22.1333L11.7539 10.4731H15.1571L21.536 19.8833L22.5295 21.3485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.74 3H6.85461C4.65571 3 2.87305 4.83837 2.87305 7.10598V36.894C2.87305 39.1616 4.65571 41 6.85461 41H35.74C37.9389 41 39.7215 39.1616 39.7215 36.894V7.10598C39.7215 4.83837 37.9389 3 35.74 3ZM26.3762 35.2247L19.5287 24.9477L10.9557 35.2247H8.73997L18.5449 23.4717L8.73997 8.75575H16.2184L22.7025 18.4874L30.8205 8.75575H33.0362L23.6866 19.9637H23.686L33.8546 35.2247H26.3762Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1422_54208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.8485,
    height: 38,
    fill: "white",
    transform: "translate(2.87305 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/TwitterIcon.422378bb7753d6b33251635d3df3b28c.svg";
export { ForwardRef as ReactComponent };